import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { AUTHOR } from "@/lib/author";

/**
 * Inline author byline — used inside pillar pages and blog posts.
 * Builds Author E-E-A-T signals (visible authorship is critical for YMYL content).
 */
export default function AuthorByline({ date, minutes }) {
  return (
    <div className="flex items-center gap-3 not-prose my-6 pb-6 border-b border-[#2c4a3b]/8" data-testid="author-byline">
      <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#bc6c25] to-[#9c581e] grid place-items-center text-white font-serif text-lg flex-shrink-0">
        SN
      </div>
      <div className="text-sm">
        <p className="text-[#1a2421]">
          Por{" "}
          <Link to="/sobre-sarai" className="font-semibold text-[#bc6c25] hover:underline">
            {AUTHOR.name}
          </Link>
        </p>
        <p className="text-xs text-[#5c6b61]">
          {AUTHOR.role}
          {date && ` · ${new Date(date).toLocaleDateString("es-MX", { year: "numeric", month: "short", day: "numeric" })}`}
          {minutes && ` · ${minutes} min de lectura`}
        </p>
      </div>
      <Link
        to="/sobre-sarai"
        className="ml-auto hidden md:inline-flex items-center gap-1 text-xs uppercase tracking-[0.18em] text-[#bc6c25] font-semibold hover:underline"
      >
        Más sobre Sarai <ChevronRight className="w-3 h-3" />
      </Link>
    </div>
  );
}
